import React, { useState } from 'react';
import './MultiSelectDropdown.css';

export interface MultiSelectDropdownProps {
  data: Array<{ id: number; name: string; [key: string]: any }>;
  onChange?: (selectedItems: Array<{ id: number; name: string }>) => void;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({ data, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<Array<{ id: number; name: string }>>([]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item: { id: number; name: string }) => {
    const isSelected = selectedItems.some(selected => selected.id === item.id);
    let newSelectedItems: Array<{ id: number; name: string }>;
    
    if (isSelected) {
      newSelectedItems = selectedItems.filter(selected => selected.id !== item.id);
    } else {
      newSelectedItems = [...selectedItems, item];
    }
    
    setSelectedItems(newSelectedItems);
    
    if (onChange) {
      onChange(newSelectedItems);
    }
  };

  return (
    <div className="multi-select-dropdown">
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedItems.length > 0 
          ? `${selectedItems.length} item(s) selected` 
          : 'Select items'}
        <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      
      {isOpen && (
        <ul className="dropdown-list">
          {data.map(item => (
            <li 
              key={item.id} 
              onClick={() => handleItemClick(item)}
              className={selectedItems.some(selected => selected.id === item.id) ? 'selected' : ''}
            >
              <input 
                type="checkbox" 
                checked={selectedItems.some(selected => selected.id === item.id)} 
                readOnly 
              />
              <span>{item.name}</span>
            </li>
          ))}
        </ul>
      )}
      
      {selectedItems.length > 0 && (
        <div className="selected-items">
          <h4>Selected Items:</h4>
          <ul>
            {selectedItems.map(item => (
              <li key={item.id}>
                {item.name}
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleItemClick(item);
                  }}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;